<template>
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-8 offset-md-2">
                <div class="card m-4">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-3 border-right cursor-pointer" :class="{ 'font-weight-bold' : this.$route.name === 'register.index' }"
                                @click="changeRegistrationType('regular')"
                            >
                                {{ $t('auth.personal_register') }}
                            </div>
                            <div class="col-12 col-md-6 col-lg-3 border-right cursor-pointer" :class="{ 'font-weight-bold' : this.$route.name === 'register.business' }"
                                @click="changeRegistrationType('business')"
                            >
                                {{ $t('auth.business_register') }}
                            </div>
                        </div>
                    </div>

                    <div class="card-body">
                        <validation-errors :errors="errors" v-if="errors" ref="errors_container" />
                        <form-status :status="status" v-if="status" />

                        <form ref="form" @submit.prevent="handleSubmit">
                            <div class="form-group row">
                                <label for="first_name" class="col-md-4 col-form-label text-md-right">{{ $t('auth.first_name') }} <span class="text-danger">*</span></label>

                                <div class="col-md-6">
                                    <input id="first_name" type="text" class="form-control" name="first_name" value="" required autocomplete="first_name" autofocus v-model="user.firstName">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="last_name" class="col-md-4 col-form-label text-md-right">{{ $t('auth.last_name') }} <span class="text-danger">*</span></label>

                                <div class="col-md-6">
                                    <input id="last_name" type="text" class="form-control" name="last_name" value="" required autocomplete="last_name" v-model="user.lastName">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="email" class="col-md-4 col-form-label text-md-right">{{ $t('auth.email') }} <span class="text-danger">*</span></label>

                                <div class="col-md-6">
                                    <input id="email" type="email" class="form-control" name="email" value="" autocomplete="email" autofocus required v-model="user.email"
                                    >
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="company_name" class="col-md-4 col-form-label text-md-right">{{ $t('company_name') }} <span class="text-danger">*</span></label>

                                <div class="col-md-6">
                                    <input id="company_name" type="text" class="form-control" name="company_name" value="" autocomplete="company_name" required v-model="user.corporateName"
                                    >
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="street" class="col-md-4 col-form-label text-md-right">{{ $t('street') }} <span class="text-danger">*</span></label>

                                <div class="col-md-6">
                                    <input id="street" type="text" class="form-control" name="street" value="" autocomplete="street" required v-model="user.addressStreet"
                                    >
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="building_number" class="col-md-4 col-form-label text-md-right">{{ $t('building_number') }} <span class="text-danger">*</span></label>
                                <div class="col-md-6">
                                    <input id="building_number" type="text" class="form-control" name="building_number" value="" autocomplete="building_number" required v-model="user.addressBuildingNumber"
                                    >
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="apartment_number" class="col-md-4 col-form-label text-md-right">{{ $t('apartment_number') }}</label>
                                <div class="col-md-6">
                                    <input id="apartment_number" type="text" class="form-control" name="apartment_number" value="" autocomplete="apartment_number" v-model="user.addressApartmentNumber"
                                    >
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="post_code" class="col-md-4 col-form-label text-md-right">{{ $t('post_code') }} <span class="text-danger">*</span></label>

                                <div class="col-md-6">
                                    <input id="post_code" type="text" class="form-control" name="post_code" value="" autocomplete="post_code" required v-model="user.addressPostal"
                                    >
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="city" class="col-md-4 col-form-label text-md-right">{{ $t('city') }} <span class="text-danger">*</span></label>

                                <div class="col-md-6">
                                    <input id="city" type="text" class="form-control" name="city" value="" autocomplete="city" required v-model="user.addressCity"
                                    >
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="country" class="col-md-4 col-form-label text-md-right">{{ $t('country') }} <span class="text-danger">*</span></label>
                                <div class="col-md-6">
                                    <select id="country" class="form-control" name="country" required v-model="user.addressCountry">
                                        <option :value="value" v-for="(label, value) in countries" :key="value">{{ label }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="tax_number" class="col-md-4 col-form-label text-md-right">{{ $t('vat_number') }} <span class="text-danger">*</span></label>

                                <div class="col-md-6">
                                    <input id="tax_number" type="text" class="form-control" name="tax_number" value=""
                                        autocomplete="tax_number" required v-model="user.nip"
                                    >
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{ $t('phone_number') }} <span class="text-danger">*</span></label>

                                <div class="col-md-6">
                                    <phone-input
                                        name="phone"
                                        input-class="form-control"
                                        required
                                        :value="user.phoneNumber"
                                        @input="onPhoneInput($event)"
                                    />
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="password" class="col-md-4 col-form-label text-md-right">{{ $t('auth.password') }} <span class="text-danger">*</span></label>

                                <div class="col-md-6">
                                    <input id="password" type="password" class="form-control" name="password" required
                                        autocomplete="current-password" v-model="user.password"
                                    >
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="password" class="col-md-4 col-form-label text-md-right">{{ $t('auth.confirm_password') }} <span class="text-danger">*</span></label>

                                <div class="col-md-6">
                                    <input id="password_confirmation" type="password" class="form-control"
                                        name="password_confirmation" required autocomplete="current-password" ref="password_confirmation">
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6 offset-md-4 col-form-label">
                                    <p><span class="text-danger">*</span> {{ $t('auth.required_fields_info') }}</p>
                                </div>
                            </div>

                            <div>
                                <input id="is_business" type="hidden" name="is_business" value="1">
                            </div>

                            <div class="row">
                                <div class="col-md-12 col-form-label text-md-center font-weight-bold">
                                    <p>{{ $t('auth.activation_warning') }}</p>
                                </div>
                            </div>

                            <div class="form-group row mb-0">
                                <div class="col-md-8 offset-md-4">
                                    <button type="submit" class="btn btn-primary" :disabled="loading">
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                                        {{ $t('auth.register') }}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ValidationErrors from '@components/ValidationErrors';
    import { mapGetters } from 'vuex';
    import backofficeRepository from '@repositories/BackofficeRepository';
    import backofficeMapsRepository from '@repositories/BackofficeMapsRepository';
    import FormStatus from '@components/FormStatus.vue';
    import toastr from 'toastr';

    export default {
        components: {
            FormStatus,
            ValidationErrors,
        },
        data() {
            return {
                errors: [],
                status: null,
                countries: this.$t('auth.countries'),
                loading: false,
            };
        },
        computed: {
            ...mapGetters({
                user: 'register/getBusinessRegisterData',
            }),
        },
        created() {
            this.$store.dispatch('register/resetBusinessRegisterData');
        },
        methods: {
            changeRegistrationType(registrationType) {
                if (registrationType === 'regular' && this.$route.name !=='register.index') {
                    this.$router.push({ name: 'register.index' });
                } else if(registrationType === 'business' && this.$route.name !== 'register.business') {
                    this.$router.push({ name: 'register.business' });
                }
            },
            async handleSubmit() {
                this.status = null;
                this.errors = [];
                this.loading = true;

                // Validate password confirmation
                if (this.user.password !== this.$refs.password_confirmation.value) {
                    this.errors.push(this.$t('validation.passwords_have_to_be_same'));
                    this.$nextTick(() => {
                        this.$refs.errors_container.$el.scrollIntoView({ behavior: 'smooth' });
                    });
                    this.loading = false;
                    return;
                }

                try {
                    const response = await backofficeRepository.registerClientUser(this.user, false);
                    if (response.data.registerClientUser.id) {
                        toastr.success(this.$t('auth.register_success'));
                        // reset form data
                        const user_email = this.user.email;
                        this.$store.dispatch('register/resetBusinessRegisterData');
                        this.$refs.password_confirmation.value = '';
                        this.$router.push({ name: 'register.confirm', params: { email: user_email } });
                    } else {
                        this.errors = backofficeMapsRepository.parseAPIErrors(response);
                        this.$nextTick(() => {
                            this.$refs.errors_container.$el.scrollIntoView({ behavior: 'smooth' });
                        });
                    }
                } catch (error) {
                    this.errors = backofficeMapsRepository.parseAPIErrors(error);
                    this.$nextTick(() => {
                        this.$refs.errors_container.$el.scrollIntoView({ behavior: 'smooth' });
                    });
                }
                finally {
                    this.loading = false;
                }
            },
            onPhoneInput(value) {
                this.$set(this.user, 'phoneNumber', value);
            },

            validatePhone() {
                let valid = true;

                if (this.user.phone && this.user.phone.length < 11) {
                    toastr.error(this.$t('airport_transfers.pages.phone_length_error'));
                    valid = false;
                }

                if (this.user.phone[0] !== '+') {
                    toastr.error(this.$t('phone_has_to_start_with_plus'));
                    valid = false;
                }

                return valid;
            },
        },
    };
</script>
